module.exports = __webpack_public_path__ + "static/media/03d.04e2cab6.svg";